<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
          <draggable v-model="config[field.key]">
            <el-col class="image-item" v-for="(item,index) in config[field.key]" :key="index">
                <el-row>
                  <i class="el-icon-remove-outline" @click="removeItem(index)"></i>
                  <el-input clearable v-model="config[field.key][index]['name']" size="small"></el-input>
                </el-row>
                <el-row>
                    <div class="link-name" v-if="config[field.key][index]['link_name']">{{config[field.key][index]['link_name']}}：{{config[field.key][index]['link_data']}}</div>
                    <el-button size="mini" @click="openDialog(index)"
                               v-text="config[field.key][index]['link_name'] ? '更换链接' : '请选择链接'"></el-button>
                    <el-button v-if="config[field.key][index]['link_name']" size="mini" class="clear-link"
                               @click="clearLink(index)">清除链接
                    </el-button>
                </el-row>
                <i class="el-icon-circle-close-outline" @click="removeImageItem(index)"></i>
            </el-col>
          </draggable>
          <el-button size="mini" @click="addImageItem()">添加导航</el-button>
        </el-form-item>
        <!-- 店铺地址对话框 -->
        <el-dialog title="请选择链接" :visible.sync="dialog.visible" @close='closeDialog'>
            <helper @select="select" @close='closeDialog'></helper>
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
    .image-item {
        position: relative;
        border: 1px solid #E3E7EE;
        background-color: #F9F9F9;
        border-radius: 4px;
        padding: 16px;
        margin-bottom: 20px;
        cursor: pointer;
        .col-left {
            flex: 0 0 150px;
        }
        .col-right {
            flex: 1;
            .link-name {
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              word-break: break-all;
              padding-right: 10px;
            }
        }
        .el-icon-circle-close-outline {
            font-size: 18px;
            position: absolute;
            top: -9px;
            right: -9px;
            cursor: pointer;
            background: #fff;
        }
        .el-icon-remove-outline{
          font-size: 22px;
          position: absolute;
          top: -26px;
          left: -26px;
          cursor: pointer;
          background: #fff;
        }
    }

    #image-list .avatar-uploader {
        width: 120px;
        margin-right: 10px;
        display: inline-block;
    }

    #image-list .avatar-uploader .el-upload {
        width: 120px !important;
        height: 120px !important;
        display: inline-block;
    }

    #image-list .avatar-uploader-icon {
        width: 120px;
        height: 120px !important;
        line-height: 120px !important;
    }

    #image-list .upload-preview-box {
        width: 120px;
        height: 120px;
    }
</style>

<script>
  import draggable from 'vuedraggable'
  import ImageUploader from '@/components/ImageUploader.vue';

  export default {
    name: 'tms-type-top-nav',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      config: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        dialog: {
          visible: false
        },
        currentIndex: 0
      }
    },

    components: {
      ImageUploader,
      draggable,
    },

    mounted() {

    },

    methods: {
      
      clearLink(index) {
        delete this.config[this.field.key][index].link_name;
        delete this.config[this.field.key][index].link_data;
        delete this.config[this.field.key][index].link_type;
        let temp = this.config[this.field.key][index];
        this.config[this.field.key].splice(index,1,temp);
      },
      addImageItem() {
        if(this.config[this.field.key].length < 20){
          this.config[this.field.key].push({})
        }
      },
      removeItem(index){
        this.config[this.field.key].splice(index, 1);
      },
      removeImageItem(index) {
        this.config[this.field.key].splice(index, 1);
      },
      handleUploadSelected(src, index) {
        this.config[this.field.key][index].selected_icon = src;
      },
      handleUploadUnSelected(src, index) {
        this.config[this.field.key][index].unselected_icon = src;
      },
      openDialog(index) {
        this.currentIndex = index;
        this.dialog.visible = true;
      },
      closeDialog() {
        this.dialog.visible = false;
      },
      select(link, linkName, linkType) {
        this.config[this.field.key][this.currentIndex].link_name = linkName;
        this.config[this.field.key][this.currentIndex].link_data = link;
        this.config[this.field.key][this.currentIndex].link_type = linkType;
        this.dialog.visible = false;
      }
    }
  }

</script>
